import {ShowController} from 'ra-core';
import React from 'react';
import {ShowView, Tab, TabbedShowLayout, TextField, ArrayField, Datagrid} from 'react-admin';
// const currentStatusList = [
//   {id: 'true', name: 'qualified'},
//   {id: 'false', name: 'disqualified'}
// ];
const RentalRequestsDetailsShow = (props) => (
  <ShowController {...props}>
    {(controllerProps) => (
      <ShowView {...props} {...controllerProps}>
        <TabbedShowLayout>
          <Tab label="Details">
            <TextField source="vendorId" label="Vendor Id" />
            <TextField source="courseName" label="Course Name" />
            <TextField source="description" label="description" />
            <ArrayField source="trainingSpecificationDetails" label="Training Specifications">
              <Datagrid>
                <TextField source="specificationName" label="Specification Name" />
                <TextField source="type" label="Type" />
                <TextField source="duration" label="Duration" />
                <TextField source="durationPeriod" label="Duration Period" />
                <TextField source="cost" label="Cost (₹)" />
                <TextField source="description" label="Description" />
              </Datagrid>
            </ArrayField>
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    )}
  </ShowController>
);

export default RentalRequestsDetailsShow;
